<template>
    <div class="base_box">
        <baseSearch @search="searchFun" :list="searchFrom">
            <template #btns="scope">
                <el-button type="primary" class="btnsty base_but_style base_search_create" @click="addFun">+添加活动</el-button>
            </template>
        </baseSearch>
        <!-- 状态标签 -->
        <div class="mt10 status-tabs">
            <el-tabs v-model="activeStatus" @tab-click="handleTabStatusChange">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane label="已结束" name="ended"></el-tab-pane>
                <el-tab-pane label="即将开始" name="upcoming"></el-tab-pane>
                <el-tab-pane label="报名中" name="signing"></el-tab-pane>
                <el-tab-pane label="比赛中" name="matching"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="mt10 base_content">
            <baseTable :loading="search.loading" :total="search.total" :page="search.post.page" :list="search.table"
                :tableList="search.tableForm" :pagesize="search.post.limit" @changePage="handlePageChange">
                <template #cover_image="scope">
                <el-image 
                    style="width: 60px; height: 60px"
                    :src="scope.row.cover_image?.url || ''" 
                    :preview-src-list="[scope.row.cover_image?.url || '']">
                </el-image>
            </template>
            <template #match_time="scope">
                <div>{{ formatDateTime(scope.row.match_start_time) }}<br/>{{ formatDateTime(scope.row.match_end_time) }}</div>
            </template>
            <template #apply_time="scope">
                <div>{{ formatDateTime(scope.row.start_time) }}<br/>{{ formatDateTime(scope.row.end_time) }}</div>
            </template>
            <template #apply_type="scope">
                <span>{{ getApplyTypeText(scope.row.apply_type) }}</span>
            </template>
            <template #statistics="scope">
                <div>投票数: {{ scope.row.vote_count || 0 }}<br/>报名人数: {{ scope.row.sign_count || 0 }}</div>
            </template>
            <template #status="scope">
                <el-switch 
                    :value="scope.row.status == 1" 
                    @change="handleStatusChange(scope.row.id, $event)"
                ></el-switch>
            </template>
                <template #operation="scope">
                    <el-button type="text" @click="contestantFun(scope.row)">选手管理</el-button>
                    <el-button type="text" @click="voteRecordFun(scope.row)">投票记录</el-button>
                    <el-button type="text" @click="editFun(scope.row)">编辑</el-button>
                </template>
            </baseTable>
        </div>
    </div>
</template>
<script>
    import baseTable from "@/components/common/baseTable.vue"
    import { eltips } from "@/util/util.js";
    import baseSearch from "@/components/common/baseSearch.vue"

    export default {
        name: 'competition-list',
        components: {
            baseTable, baseSearch
        },
        data() {
            return {
                activeStatus: 'all',
                search: {
                    post: {
                        title: '',
                        apply_type: '',
                        audit_status: '',
                        status: '',
                        start_time: '',
                        competition_status: '',
                        page: 1,
                        limit: 10
                    },
                    loading: false,
                    total: 0,
                    tableForm: [
                        { label: 'ID', prop: 'id', width: 50 },
                        { label: '活动名称', prop: 'title', width: 250 },
                        { label: '类型', prop: 'apply_type', width: 80 },
                        { label: '活动图片', prop: 'cover_image', width: 160 },
                        { label: '比赛时间', prop: 'match_time', width: 220 },
                        { label: '报名时间', prop: 'apply_time', width: 220 },
                        { label: '统计', prop: 'statistics', width: 150 },
                        { label: '开启/关闭', prop: 'status', width: 100 },
                        { label: '创建时间', prop: 'created_at', width: 200 },
                        { label: '操作', prop: 'operation', width: 260 }
                    ],
                    table: []
                },
                searchFrom: [
                    {
                        type: "input",
                        Field: "title",
                        label: "活动名称",
                        placeholder: "请输入活动名称",
                        style: { width: '200px' }
                    },
                    {
                        type: "select",
                        Field: "apply_type",
                        label: "类型",
                        placeholder: "全部",
                        style: { width: '150px' },
                        options: [
                            { value: '', label: '全部' },
                            { value: '1', label: '图片投票' },
                            { value: '2', label: '视频投票' },
                        ]
                    },
                    // {
                    //     type: "select",
                    //     Field: "competition_status",
                    //     label: "活动阶段",
                    //     placeholder: "全部",
                    //     style: { width: '150px' },
                    //     options: [
                    //         { value: '', label: '全部' },
                    //         { value: 'upcoming', label: '即将开始' },
                    //         { value: 'signing', label: '报名中' },
                    //         { value: 'matching', label: '比赛中' },
                    //         { value: 'ended', label: '已结束' }
                    //     ]
                    // }
                ]
            }
        },
        created() {
            this.getList()
        },
        methods: {
            searchFun(val) {
                this.search.post = { ...this.search.post, ...val, page: 1 }
                this.getList()
            },
            handlePageChange(page) {
                this.search.post.page = page
                this.getList()
            },
            handleTabStatusChange(tab) {
                this.search.post.page = 1
                switch (tab.name) {
                    case 'all':
                        this.search.post.status = ''
                        break
                    case 'ongoing':
                        this.search.post.status = '1'
                        break
                    case 'ended':
                        this.search.post.status = '0'
                        break
                }
                this.search.post.page = 1
                this.getList()
            },
            handleStatusChange(id, value) {
                const _this = this
                const status = value ? 1 : 0
                _this.axios.post(`/api/sing/admin/competition/status/${id}`, { status: status }).then(res => {
                    if (res.code == 200) {
                        _this.$message.success(status == 1 ? '活动已开启' : '活动已关闭')
                        _this.getList()
                    } else {
                        _this.$message.error(res.msg || '操作失败')
                    }
                }).catch(err => {
                    _this.$message.error('操作失败')
                })
            },
            getList() {
                const _this = this
                _this.search.loading = true
                _this.axios.get('/api/sing/admin/competition/list', { params: _this.search.post }).then(res => {
                    _this.search.loading = false
                    if (res.code == 200) {
                        _this.search.table = res.data.data
                        _this.search.total = res.data.total
                        console.log(181, res);
                        
                    }
                }).catch(() => {
                    _this.search.loading = false
                })
            },
            getApplyTypeText(type) {
                const types = {
                    1: '图片投票',
                    2: '视频投票',
                }
                return types[type] || '-'
            },
            formatDateTime(dateStr) {
                if (!dateStr) return '-'
                const date = new Date(dateStr)
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                const hours = String(date.getHours()).padStart(2, '0')
                const minutes = String(date.getMinutes()).padStart(2, '0')
                const seconds = String(date.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            },
            addFun() {
                sessionStorage.setItem('competition_crumbs', JSON.stringify([
                    { name: '投票活动', path: '/application/competition/list', query: '' },
                    { name: '添加活动', path: '', query: '' }
                ]))
                this.$router.push('/application/competition/add')
            },
            editFun(row) {
                sessionStorage.setItem('competition_crumbs', JSON.stringify([
                    { name: '投票活动', path: '/application/competition/list', query: '' },
                    { name: '编辑活动', path: '', query: '' }
                ]))
                this.$router.push('/application/competition/edit/' + row.id)
            },
            contestantFun(row) {
                // 跳转到选手列表页面，传递活动ID
                this.$router.push({ path: '/weishop/application/sign/list', query: { competition_id: row.id } })
            },
            voteRecordFun(row) {
                // 跳转到投票记录列表页面，传递活动ID
                this.$router.push({ path: '/weishop/application/voteLog/list', query: { competition_id: row.id } })
            }
        }
    }
</script>
<style scoped>
    .status-tabs {
        margin-top: 10px;
    }
</style>